<mat-form-field
	#popoverTrigger="mtxPopoverTrigger"
	(click)="
		$event.stopPropagation();
		accountsList.length == 0 ? loadInitialAccountsList() : null;
		focusToSearchInput()
	"
	[mtxPopoverTriggerFor]="customerPopover"
	class="{{ customFormFieldClass }}"
	floatLabel="never"
	fxFlex
	mtxPopoverTriggerOn="click"
>
	<mat-label [ngClass]="{ 'primary-text': placeholder !== 'Business Name' }" class="capitalize">{{
		placeholder
	}}</mat-label>
	<input matInput readonly="true" />
	<mat-icon *ngIf="renderDownArrowIcon()" class="vertical-align-middle" matSuffix
		>keyboard_arrow_down
	</mat-icon>
	<mat-icon
		(click)="$event.stopPropagation(); removeSelectedAccount()"
		*ngIf="renderCloseArrowIcon()"
		class="vertical-align-middle danger-text cursor-pointer"
		matSuffix
	>
		close
	</mat-icon>
</mat-form-field>

<mtx-popover [closeOnPanelClick]="false" #customerPopover="mtxPopover">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="customers-dropdown font-size-14 p-b-2">
			<div class="padding-0-5" fxLayout="row">
				<mat-form-field fxFlex>
					<input
						#searchInput
						(input)="inputChanged($event.target.value)"
						[(ngModel)]="searchText"
						autocomplete="off"
						class="capitalize"
						matInput
						placeholder="Type to filter"
					/>
				</mat-form-field>
			</div>
			<div *ngIf="isLoadingAccountsList" class="padding-0-5" fxLayout="row">
				<div fxFlex fxLayoutAlign="center center">
					<mat-spinner [diameter]="11"></mat-spinner>
				</div>
			</div>

			<div
				(click)="setSelectedAccount(account)"
				*ngFor="let account of accountsList"
				class="padding-0-5 customer-row cursor-pointer"
				fxLayout="row"
			>
				<div class="primary-text capitalize" fxFlex fxLayoutAlign="start center">
					{{ account.businessName }}
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</mtx-popover>
